function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M239.5 283.5H44c-24.3-.1-44-19.8-44-44.1V128.9c0-24.3 19.7-44 44-44.1h195.5c24.3.1 44 19.8 44 44.1v110.5c0 24.3-19.7 44-44 44.1zM44 113.3c-8.6 0-15.6 7-15.6 15.6v110.5c0 8.6 7 15.6 15.6 15.6h195.5c8.6 0 15.6-7 15.6-15.6V128.9c0-8.6-7-15.6-15.6-15.6H44z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M123 240.8l56.6-70.8h-33.3l12.2-42.5-56.6 70.8h33.3zM85 28.2H56.8V0H42.3v28.2H14.2v14.5h28.1v28.2h14.5V42.7H85z"
})));